import { motion } from 'framer-motion';
import Footer from '../components/Footer';

const PartnershipsPage = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.8,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.6 }
    }
  };

  return (
    <div>
      <section className="pt-32 pb-20 bg-gradient-to-br from-tev-green to-tev-green-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center text-white"
          >
            <h1 className="text-5xl font-bold mb-6">Our Partnerships</h1>
            <p className="text-xl max-w-3xl mx-auto opacity-90">
              Building sustainable relationships for agricultural growth
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Outgrowers Section */}
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            className="mb-16"
          >
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <div className="flex items-center mb-6">
                  <div className="bg-green-600 text-white p-3 rounded-full mr-4">
                    <i className="fas fa-users text-2xl"></i>
                  </div>
                  <h3 className="text-2xl font-semibold text-gray-900">Our Outgrowers</h3>
                </div>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  Among our core values is caring for our communities and collaborating with them as partners for growth. As they succeed, so do we. To that end, we are making significant investments in capacitating producers in several districts in Malawi, to be our outgrowers.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Through this partnership, we support them with inputs, extension support and climate resilient solutions such as irrigation services, to maximize their potential for success.
                </p>
              </div>
              <motion.div
                variants={itemVariants}
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.3 }}
              >
                <img 
                  src="/images/partner.jpg" 
                  alt="Outgrowers Partnership" 
                  className="rounded-lg shadow-lg w-full h-64 object-cover"
                />
              </motion.div>
            </div>
          </motion.div>
          
          {/* Research & Development Section */}
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            className="bg-gradient-to-r from-blue-50 to-indigo-50 p-8 rounded-xl"
          >
            <div className="flex items-center mb-6">
              <div className="bg-blue-600 text-white p-3 rounded-full mr-4">
                <i className="fas fa-microscope text-2xl"></i>
              </div>
              <h3 className="text-2xl font-semibold text-gray-900">Research & Development Backstopping</h3>
            </div>
            <p className="text-gray-700 mb-6">
              Our association with following global research institutions has proved to be essential for our agronomy activities:
            </p>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-white p-6 rounded-lg shadow-md">
                <div className="flex items-center mb-4">
                  <i className="fas fa-seedling text-green-600 text-xl mr-3"></i>
                  <h4 className="font-semibold text-gray-900">Common Beans</h4>
                </div>
                <p className="text-gray-600">The Alliance of Bioversity International and CIAT</p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md">
                <div className="flex items-center mb-4">
                  <i className="fas fa-leaf text-green-600 text-xl mr-3"></i>
                  <h4 className="font-semibold text-gray-900">Cassava</h4>
                </div>
                <p className="text-gray-600">The International Institute of Tropical Agriculture (IITA)</p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md">
                <div className="flex items-center mb-4">
                  <i className="fas fa-circle text-amber-600 text-xl mr-3"></i>
                  <h4 className="font-semibold text-gray-900">Peanuts</h4>
                </div>
                <p className="text-gray-600">The International Crops Research Institute for Semi-Arid Tropics (ICRISAT)</p>
              </div>
            </div>
            <p className="text-gray-700 mt-6 italic">
              Through these partnerships, we have access to latest research, technologies and best practices in seed multiplication, as well as agronomy generally.
            </p>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PartnershipsPage;
